import * as React from "react";
import './Pick.css';
import '../../components/Typograph.css';
import {sendOfferteAanvraag} from "../../util/Send";
import {useEffect, useState} from "react";
import PropTypes from "prop-types";
import PhoneAppHeader from "../../components/PhoneAppHeader";
import PhoneAppFooter from "../../components/PhoneAppFooter";
import WarningBox from "../../components/WarningBox";

ContactPick.propTypes = {
    handleNextPage: PropTypes.func.isRequired,
    handlePreviousPage: PropTypes.func.isRequired,
    handlePageChange: PropTypes.func.isRequired,
    allValues: PropTypes.object.isRequired,
    disablePhoneMode: PropTypes.func.isRequired,
}

export default function ContactPick(props) {
    const currentValue = props.allValues.ContactPick;

    const [file1, setFile1] = useState(null);
    const [file2, setFile2] = useState(null);
    const [file3, setFile3] = useState(null);
    const [file4, setFile4] = useState(null);
    const [disableNavigation, setDisableNavigation] = useState(false);
    const [clickedSend, setClickedSend] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            const data = JSON.parse(JSON.stringify(currentValue || {}));

            if (value("aanhef") === "") {
                data["aanhef"] = "Dhr";
            }
            if (value("land") === "") {
                data["land"] = "NL";
            }

            if (value("finished") === "") {
                data["finished"] = "ja";
            }
            props.handlePageChange(data);
        }, 1);
    }, []);

    const onChange = (field) => (e: InputEvent) => {
        const data = JSON.parse(JSON.stringify(currentValue || {}));
        data[field] = e.currentTarget.value;
        props.handlePageChange(data);
    }

    const value = (field) => {
        const val = (currentValue || {})[field];
        return val != null ? val : "";
    }

    const canContinue = () => {
        const c = currentValue || {};
        const wrong = [];

        const email = c.email;
        if (email == null || email === "" || !email.includes('@')) {
            wrong.push("E-mail");
        }

        const huisnummer = c.huisnummer;
        if (huisnummer == null || huisnummer === "") {
            wrong.push("Huisnummer");
        }

        const voornaam = c.voornaam;
        if (voornaam == null || voornaam === "") {
            wrong.push("Voornaam");
        }

        const achternaam = c.achternaam;
        if (achternaam == null || achternaam === "") {
            wrong.push("Achternaam");
        }

        const postcode = c.postcode;
        if (postcode == null || postcode === "" || postcode.length < 6) {
            wrong.push("Postcode");
        }

        const straat = c.straat;
        if (straat == null || straat === "") {
            wrong.push("Straat");
        }

        const woonplaats = c.woonplaats;
        if (woonplaats == null || woonplaats === "") {
            wrong.push("Woonplaats");
        }

        if (wrong.length > 0) {
            return "U heeft niet alle velden (volledig) ingevuld:\n" + wrong.join(', ');
        } else {
            return null;
        }
    }

    const onNext = () => {
        setClickedSend(true);
        function realValue(val) {
            if (val.text != null) {
                return `${val.value} ${val.text}`;
            }
            return val;
        }

        const c = currentValue || {};
        const wrong = [];

        const email = c.email;
        if (email == null || email === "" || !email.includes('@')) {
            wrong.push("E-mail");
        }

        const huisnummer = c.huisnummer;
        if (huisnummer == null || huisnummer === "") {
            wrong.push("Huisnummer");
        }

        const voornaam = c.voornaam;
        if (voornaam == null || voornaam === "") {
            wrong.push("Voornaam");
        }

        const achternaam = c.achternaam;
        if (achternaam == null || achternaam === "") {
            wrong.push("Achternaam");
        }

        const postcode = c.postcode;
        if (postcode == null || postcode === "" || postcode.length < 6) {
            wrong.push("Postcode");
        }

        const straat = c.straat;
        if (straat == null || straat === "") {
            wrong.push("Straat");
        }

        const woonplaats = c.woonplaats;
        if (woonplaats == null || woonplaats === "") {
            wrong.push("Woonplaats");
        }

        if (wrong.length > 0) {
            return;
        }

        setDisableNavigation(true);

        sendOfferteAanvraag({
                type: realValue(props.allValues.TypePick),
                versie: realValue(props.allValues.VersionPick),
                sluiting: realValue(props.allValues.ClosingPick),
                vastzetter: realValue(props.allValues.FastenerPick),
                situaties: props.allValues.SituationPick.data, //[{kozijnen, luiken, breedte, hoogte, montage, draaitype, hengtype, maatD, maatM, maatT, maatA, maatK}] all String?
                info: props.allValues.ContactPick //{extraInfo?, email, finished, huisnummer, mobile?, voornaam, achternaam, aanhef, postcode, straat, tel?, woonplaats}
            }, file1, file2, file3, file4
        ).then(r => {
            if (r.ok) {
                props.handleNextPage();
            } else {
                setDisableNavigation(false);
                console.log("Error sending 'offerte aanvraag': " + r.status);
                alert("Er is helaas iets mis gegaan bij het versturen van uw aanvraag.\nGraag later opnieuw proberen of zelf mailen naar info@luikbeslagshop.nl")
            }
        });
    }


    const maxFileSize = 5 * 1024 * 1024;
    return (
        <div className="page">
            <PhoneAppHeader title="Contact informatie"
                            quitPhoneApp={props.disablePhoneMode}
                            onPrevious={props.handlePreviousPage}/>

            <div className="phone-page-middle">
                <div style={{margin: "10px"}}>
                    <h1 className="phone-pick-title-sub">Heeft u nog opmerkingen, vragen of belangrijke informatie?</h1>

                    <textarea className="phone-extra-info" value={value("extraInfo")}
                              onChange={onChange("extraInfo")}/>
                    <hr/>
                    <h1 className="phone-pick-title-sub">Indien gewenst kunt u foto's of illustraties meesturen.</h1>
                    <div style={{marginLeft: "10px"}}>
                        <input type="file" style={{width: "100%"}}
                               onChange={e => {
                                   if (e.target.files[0].size > maxFileSize) {
                                       alert("U kunt alleen bestanden opsturen onder de 5 MB");
                                       e.target.value = '';
                                   } else {
                                       setFile1(e.target.files[0]);
                                   }
                               }}/>
                        <input type="file" style={{width: "100%"}}
                               onChange={e => {
                                   if (e.target.files[0].size > maxFileSize) {
                                       alert("U kunt alleen bestanden opsturen onder de 5 MB");
                                       e.target.value = '';
                                   } else {
                                       setFile2(e.target.files[0]);
                                   }
                               }}/>
                        <input type="file" style={{width: "100%"}}
                               onChange={e => {
                                   if (e.target.files[0].size > maxFileSize) {
                                       alert("U kunt alleen bestanden opsturen onder de 5 MB");
                                       e.target.value = '';
                                   } else {
                                       setFile3(e.target.files[0]);
                                   }
                               }}/>
                        <input type="file" style={{width: "100%"}}
                               onChange={e => {
                                   if (e.target.files[0].size > maxFileSize) {
                                       alert("U kunt alleen bestanden opsturen onder de 5 MB");
                                       e.target.value = '';
                                   } else {
                                       setFile4(e.target.files[0]);
                                   }
                               }}/>
                    </div>
                    <hr/>
                    <h1 className="phone-pick-title-sub">Het luikbeslag is voor</h1>
                    <div style={{marginLeft: "10px"}}>
                        <input type="radio" value="ja" id="finished-yes"
                               checked={value("finished") === "ja"}
                               onChange={onChange("finished")}/>
                        <label htmlFor="finished-yes">bestaande luiken.</label><br/>
                        <input type="radio" value="nee" id="finished-no"
                               checked={value("finished") === "nee"}
                               onChange={onChange("finished")}/>
                        <label htmlFor="finished-no">nog te maken luiken.</label>
                    </div>
                    <hr/>
                    <h4>Uw gegevens</h4>
                    <div className={"form"}>
                        <div className={"phone-form-part"}>
                            <div>
                                <div>Voor- en achternaam*</div>
                                <select onChange={onChange("aanhef")} value={value("aanhef")}>
                                    <option value="Dhr">Dhr</option>
                                    <option value="Mw">Mw</option>
                                </select>
                                <input type="text" className={"phone-form-input"} value={value("voornaam")}
                                       onChange={onChange("voornaam")} size="15"/>
                                <input type="text" className={"phone-form-input"} value={value("achternaam")}
                                       onChange={onChange("achternaam")} size="15"/>
                            </div>
                        </div>
                        <div className={"phone-form-part"}>
                            <div>
                                <div>Land</div>
                                <select onChange={onChange("land")} value={value("land")}>
                                    <option value="NL">Nederland</option>
                                    <option value="BE">België</option>
                                    <option value="DE">Duitsland</option>
                                    <option value="FR">Frankrijk</option>
                                </select>
                            </div>
                        </div>
                        <div className={"phone-form-part"}>
                            <div>
                                <div>Straat*</div>
                                <input type="text" value={value("straat")} onChange={onChange("straat")}
                                       size="24"/>
                            </div>
                            <div>
                                <div className={"phone-form-input"}>Huisnummer*</div>
                                <input className={"phone-form-input"} type="text" value={value("huisnummer")}
                                       onChange={onChange("huisnummer")} size="5"/>
                            </div>

                            <div>
                                <div>Tel.</div>
                                <input type="text" value={value("toevoeging")} onChange={onChange("toevoeging")}
                                       size="3"/>
                            </div>
                        </div>
                        <div className={"phone-form-part"}>
                            <div>
                                <div>Postcode*</div>
                                <input type="text" value={value("postcode")}
                                       onChange={onChange("postcode")}
                                       size="6"/>
                            </div>
                            <div>
                                <div className={"phone-form-input"}>Woonplaats*</div>
                                <input className={"phone-form-input"} type="text" value={value("woonplaats")}
                                       onChange={onChange("woonplaats")} size="25"/>
                            </div>
                        </div>
                        <div className={"phone-form-part"}>
                            <div>
                                <div>E-mail*</div>
                                <input type="email" value={value("email")} onChange={onChange("email")}
                                       size="37"/>
                            </div>
                        </div>
                        <div className={"phone-form-part"}>
                            <div>
                                <div>Tel.</div>
                                <input type="tel" value={value("tel")} onChange={onChange("tel")}
                                       size="15"/>
                            </div>
                            <div>
                                <div className={"phone-form-input"}>Mobiel</div>
                                <input className={"phone-form-input"} type="mobile" value={value("mobile")}
                                       onChange={onChange("mobile")} size="16"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <WarningBox
                warning={clickedSend ? canContinue() : null}
                sticky/>
            {disableNavigation
                ? <PhoneAppFooter onNext={onNext}
                                  enableNext={false}
                                  send={true}/>
                : <PhoneAppFooter onNext={onNext}
                                  onPrevious={() => {
                                      if (file1 != null || file2 != null || file3 != null || file4 != null) {
                                          if (window.confirm("Als u terug gaat moet u de foto's opnieuw invoeren\nToch teruggaan?")) {
                                              props.handlePreviousPage();
                                          }
                                      } else {
                                          props.handlePreviousPage();
                                      }
                                  }}
                                  enableNext={!clickedSend || canContinue() == null}
                                  send={true}/>
            }
        </div>
    );
}
